import { fetchCall, fetchLoginCall, fetchNoCall } from "./ajax";
import { API_CONSTANTS, API_METHODS } from "./api-constant";

export const UserLogin = (callback, payload) => {
  const url = `${API_CONSTANTS.LOGIN}`;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const UserRegister = (callback, payload) => {
  const url = `${API_CONSTANTS.REGISTER}`;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const getRefreshToken = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_REFRESH_TOKEN}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetAllDepartment = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_ALL_DEPARTMENT}`;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetAllAccessLevel = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_ALL_ACCESSLEVEL}`;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const UserForgotPassword = (callback, payload) => {
  const url = `${API_CONSTANTS.FORGOT_PASSWORD}`;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const ValidateURL = (callback, token) => {
  const queryString = `?token=${token}`;
  const url = `${API_CONSTANTS.VALIDATE_URL + queryString}`;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST
  );
};

export const ValidateOTP = (callback, payload) => {
  const url = `${API_CONSTANTS.VALIDATE_OTP}`;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const LearnerDashBoardCount = (callback) => {
  const url = `${API_CONSTANTS.LEARNER_DASHBOARD}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET
  );
};


export const GetAllLearnerList = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_ALL_LEARNERS}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const ContactSupportAPI = (callback, payload) => {
  const url = `${API_CONSTANTS.CONTACT_SUPPORT}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const ResetPasswordAPI = (callback, payload) => {
  const url = `${API_CONSTANTS.RESET_PASSWORD}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const AddLearnerData = (callback, payload) => {
  const url = `${API_CONSTANTS.ADD_LEARNER}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetDownLoadLearnerExcel = (callback) => {
  const url = `${API_CONSTANTS.DOWNLOAD_LEARNER_EXCEL}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET
  );
};

export const BatchUploadLearner = (callback, payload) => {
  const url = `${API_CONSTANTS.BATCH_UPLOAD_EXCEL}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetLearnersByID = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_LEARNERS_BY_ID}?userId=${payload}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET
  );
};

export const DeleteLearner = (callback, payload) => {
  const url = `${API_CONSTANTS.REMOVE_LEARNER}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const UpdateLearner = (callback, payload) => {
  const url = `${API_CONSTANTS.UPDATE_LEARNER}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const RevokeBadgeFromLearner = (callback, payload) => {
  const url = `${API_CONSTANTS.REVOKE_BADGE_FROM_LEARNER}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const RemoveBadge = (callback, payload) => {
  const url = `${API_CONSTANTS.REMOVE_BADGE}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const RemoveProfilePicture = (callback, payload) => {
  const url = `${API_CONSTANTS.REMOVE_PROFILE_PICTURE}?userId=${payload}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

//Staff
export const GetAllStaff = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_ALL_STAFF}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const ArchiveStaff = (callback, payload) => {
  const url = `${API_CONSTANTS.ARCHIVED_STAFFS}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const AddStaffData = (callback, payload) => {
  const url = `${API_CONSTANTS.ADD_STAFF}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetStaffByID = (callback, userId) => {
  const url = `${API_CONSTANTS.GET_STAFF_BY_ID}?userId=${userId}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST
  );
};

export const UpdateStaff = (callback, payload) => {
  const url = `${API_CONSTANTS.UPDATE_STAFF}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const DeleteStaff = (callback, payload) => {
  const url = `${API_CONSTANTS.DELETE_STAFF}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetBadgeSequence = (callback) => {
  const url = `${API_CONSTANTS.GET_BADGE_SEQUENCE}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET
  );
};

export const GetAllApprovalUsers = (callback, departmentId) => {
  const url = `${API_CONSTANTS.GET_ALL_APPROVAL_USERS}?departmentId=${departmentId}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST
  );
};

//Credentials
export const GetAllBadges = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_ALL_BADGES}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetUnApprovedBadges = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_UNAPPROVED_BADGES}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetBadgeSortOptions = (callback) => {
  const url = `${API_CONSTANTS.GET_BADGE_SORT_OPTIONS}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const ApproveBadge = (callback, payload) => {
  const url = `${API_CONSTANTS.APPROVE_BADGE}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const DeleteBadge = (callback, payload) => {
  const url = `${API_CONSTANTS.DELETE_BADGE}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetBadgePictures = (callback,payload) => {
  const url = `${API_CONSTANTS.GET_BADGE_PICTURES}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const AssignBadges = (callback, payload) => {
  const url = `${API_CONSTANTS.ASSIGN_BADGES}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetLearnersForBadgeAssign = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_LEARNERS_FOR_BADGE_ASSIGN}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const AddBadge = (callback, payload) => {
  const url = `${API_CONSTANTS.ADD_BADGE}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const UpdateBadge = (callback, payload) => {
  const url = `${API_CONSTANTS.UPDATE_BADGE}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetBadgeById = (callback, badgeId) => {
  const url = `${API_CONSTANTS.GET_BADGE_BY_ID}?badgeId=${badgeId}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST
  );
};

export const BadgeFactoryDashBoardCount = (callback) => {
  const url = `${API_CONSTANTS.BADGE_FACTORY_DASHBOARD}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET
  );
};

export const UserChangePassword = (callback, payload) => {
  const url = `${API_CONSTANTS.CHANGE_PASSWORD}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetDeletedUsersSortOptions = (callback) => {
  const url = `${API_CONSTANTS.GET_DELETED_USER_SORT_OPTIONS}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const GetAllDeletedUsers = (callback, payload) => {
  const url = `${API_CONSTANTS.GET_ALL_DELETED_USER}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const GetAllBadgeType = (callback) => {
  const url = `${API_CONSTANTS.GET_ALL_BADGETYPE}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const GetStaffSort = (callback) => {
  const url = `${API_CONSTANTS.GET_ALL_STAFFSORT}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const AddDepartment = (callback, departmentName) => {
  const url = `${API_CONSTANTS.ADD_DEPARTMENT}?departmentName=${departmentName}`;
  return fetchLoginCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST
  );
};